var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloMutation',{attrs:{"mutation":function (gql) { return _vm.deleteChapterConnectorQuery; },"variables":{
    chapterConnectorId: _vm.connectionId,
  },"update":_vm.updateCache},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var mutate = ref.mutate;
  var loading = ref.loading;
return [_c('v-btn',{staticClass:"rounded-xl ml-1",attrs:{"x-small":"","elevation":0,"fab":"","color":"secondaryAction","disabled":loading,"loading":loading},on:{"click":function($event){return mutate()}}},[_c('v-icon',[_vm._v("mdi-minus")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }